// Progress Messages
export const PROGRESS_MESSAGES = {
  STARTING_MIGRATION: 'Starting migration...',
  PREPARING_MIGRATION: 'Preparing for migration...',
  GENERATING_CONFIG: 'configuration...',
  ONBOARDING_SAVIYNT: 'Onboarding to Saviynt...',
  MIGRATION_COMPLETED: 'Migration completed',
  MIGRATION_FAILED: 'Migration failed',
  CONFIG_GENERATION_FAILED: 'Configuration generation failed',
  MISSING_REQUIRED_CONFIG: 'Missing required configuration',
  BULK_ONBOARD_FAILED: 'Bulk onboard failed',
  DISCOVERY_IN_PROGRESS: 'Discovery in progress...',
  DISCOVERY_COMPLETED: 'Discovery completed successfully! (100%)',
  PROCESSING: 'Processing... this might take a few minutes.',
  COMPLETING_OPERATION: 'Completing operation...',
  STARTING: 'Starting...',
  UPLOADING_FILE: 'Uploading objects file...',
  PROCESSING_UPLOADED_DATA: 'Processing uploaded data...',
};

// Error Messages
export const ERROR_MESSAGES = {
  SOURCE_NOT_CONFIGURED: 'Source not configured',
  SOURCE_NOT_CONFIGURED_DETAIL:
    'Source not configured. Please Configure in Prerequisites Settings first.',
  DISCOVERY_ALREADY_COMPLETED:
    'Discovery already completed! You can view the results in the Visibility tab.',
  COMPLETE_DISCOVERY_FIRST_CONFIG:
    'Please complete discovery first before migrating configuration.',
  COMPLETE_DISCOVERY_FIRST_DATA: 'Please complete discovery first before migrating data.',
  BACKEND_UNAVAILABLE: 'Backend Service Unavailable',
  CANNOT_CONNECT_BACKEND: 'Something went wrong. Please try again in a moment.',
  NO_DATA_AVAILABLE: 'No data available',
  DISPATCH_REQUIRED: 'Dispatch is required for getSourceIdFromType',
  FAILED_TO_PARSE: 'Failed to parse response',
  NETWORK_ERROR: 'Network error',
  INVALID_PROTOCOL: 'Invalid protocol',
  HOST_NOT_ALLOWED: 'Host not allowed',
  PATH_NOT_ALLOWED: 'Path not allowed',
  INVALID_URL: 'Invalid URL',
  CONFIGURATION_ERROR: 'Configuration error. Please verify your settings.',
  RESOURCE_NOT_FOUND: 'Resource not found. Please check your configuration.',
  UNSUPPORTED_APP_TYPE:
    'Unsupported application type. Please check supported types in configuration.',
  FAILED_UPLOAD_FILE: 'Failed to upload simulation file.',
  FAILED_SAVE_CONFIG: 'Failed to save configuration.',
  FAILED_SAVE_AI_AGENT_CONFIG: 'Failed to save AI Agent configuration.',
  FAILED_SAVE_DISCONNECTED_DISCOVERY_CONFIG: 'Failed to save Disconnected Discovery configuration.',
};

// Success Messages
export const SUCCESS_MESSAGES = {
  COMPLETED_CHECKMARK: 'Completed ✓',
  IDENTITY_MIGRATION_SUCCESS: 'Identity migration completed successfully!',
  CONFIG_SAVED: 'Configuration saved successfully.',
  AI_AGENT_CONFIG_SAVED: 'AI Agent configuration saved successfully.',
  DISCONNECTED_DISCOVERY_CONFIG_SAVED: 'Disconnected Discovery configuration saved successfully.',
};

// Button Labels
export const BUTTON_LABELS = {
  DISCOVER: 'Discover',
  DISCOVERING: 'Discovering...',
  MIGRATE_CONFIGURATION: 'Migrate Configuration',
  MIGRATE_DATA: 'Migrate Data',
  CLEAR_SELECTION: 'Clear Selection',
  MIGRATE: 'Migrate',
  MIGRATING: 'Migrating...',
  CONFIGURE: 'Configure',
  EDIT_CONFIGURATION: 'Edit Configuration',
  SETTINGS: 'Settings',
  SAVE: 'Save',
  CANCEL: 'Cancel',
  SUBMIT: 'Submit',
  BROWSE: 'Browse',
};

// Titles
export const TITLES = {
  CONFIGURATION_MIGRATION: 'Configuration Migration',
  DATA_MIGRATION: 'Data Migration',
  OBJECT_VISIBILITY: 'Object Visibility',
  IDENTITIES: 'Identities',
  APPLICATIONS_DATA: 'Applications Data',
  WORKGROUPS_DATA: 'Workgroups Data',
  OIM_MIGRATION: 'OIM Migration',
  SAILPOINT_MIGRATION: 'SailPoint Migration',
  PREREQUISITES: 'Prerequisites (Initial Setup)',
  DISCOVER_OBJECTS: 'Discover Objects (Visibility)',
  DISCONNECTED_DISCOVERY: 'Disconnected Discovery',
  DATA_MIGRATION_SETTINGS: 'Data Migration Settings',
  AI_AGENT_SERVICE: 'Use AI Agent Service',
  DISCONNECTED_DISCOVERY_TITLE: 'Disconnected Discovery via .zip File Upload',
};

// Descriptions
export const DESCRIPTIONS = {
  CONFIGURE_CONNECTION_FIRST:
    'Please configure your connection in Global Settings before accessing migration features.',
  CHECKING_CONFIGURATION: 'Checking configuration...',
  MIGRATING_APPLICATIONS: 'Migrating applications...',
  MIGRATING_IDENTITIES: 'Migrating identities...',
  PREREQUISITES:
    'Configure connection settings and user attribute mappings before starting migration.',
  DATA_MIGRATION_SETTINGS: 'Enable or disable data migration for this source.',
  AI_AGENT_SERVICE: 'Enable or disable AI Agent Service for this source.',
  DISCONNECTED_DISCOVERY:
    'Lets discovery of objects via file upload, instead of connecting to the selected source system.',
  DISCONNECTED_DISCOVERY_MODAL: 'Upload a zip file from source to discover the objects.',
  ENABLE_DATA_MIGRATION: 'Allow data migration for this source system',
  ENABLE_AI_AGENT: 'Allow AI Agent Service for this source system',
  ENABLE_DISCONNECTED_DISCOVERY: 'Allow disconnected discovery at the workbench level',
  ZIP_FILES_ONLY: 'Only .zip files are allowed',
};

// Status Labels
export const STATUS_LABELS = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  SUCCESS: 'SUCCESS',
};

// Object Type Labels
export const OBJECT_TYPE_LABELS = {
  WORKGROUP: 'Workgroup',
  PASSWORD_POLICY: 'PasswordPolicy',
  APPLICATION: 'Application',
  BUNDLE: 'Bundle',
  ENTERPRISE_ROLES: 'Enterprise Roles',
};

// UI Labels
export const UI_LABELS = {
  NO_OBJECTS_FOUND: 'No objects found',
  SELECT_OBJECTS: 'Select objects to migrate.',
  SELECT_AVAILABLE: 'Select Available',
  ID: 'ID',
  TYPE: 'Type',
  CONNECTOR: 'Connector',
  CREATED: 'Created',
  MODIFIED: 'Modified',
  CONFIG_PREVIEW: 'Config Preview',
  MIGRATION_COMPLETE_NO_REMIGRATE: 'Migration complete (Cannot re-migrate)',
  READY_TO_MIGRATE: 'Ready to migrate',
  PARENT_BUNDLE:
    'When you migrate this Business bundle (role), any dependent IT bundles (roles) will also be migrated automatically',
  BUNDLE_PREREQUISITE:
    'Prerequisite: Please ensure all associated applications and entitlements are migrated first.',
  IMPORT_JOB_CREATED: 'Import Job Created',
  MEMBERSHIPS_MIGRATED: 'Memberships Migrated',
  DISCONNECTED_APPLICATION: 'Disconnected Application',
  MIGRATION_FAILED: 'Migration Failed',
  ALL_STATUS: 'All Status',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  SORT_BY_NAME: 'Sort by Name',
  SORT_BY_CREATED: 'Sort by Created',
  SORT_BY_MODIFIED: 'Sort by Modified',
  SHOW_LESS: 'Show less',
  SHOW_MORE: 'Show more',
  MIGRATE: 'Migrate',
  VIEW: 'View',
  OBJECT: 'object',
  OBJECTS: 'objects',
  OIM: 'OIM',
  SAILPOINT: 'SailPoint',
  SAVIYNT: 'Saviynt',
  OVERVIEW_DISCOVERED: 'Overview of discovered objects in your',
  ENVIRONMENT: 'environment',
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning',
  USER_GROUP: 'User group',
  USER_GROUP_DESCRIPTION: 'User group description',
  POLICY_NAME: 'Policy Name',
  DESCRIPTION: 'Description',
  SELECT_APPLICATIONS: 'Please select applications to migrate',
  IDENTITY_MIGRATION_FAILED: 'Identity migration failed',
  JOBS_NOT_EXECUTED: 'Jobs will be created but not executed (you can run them later from Saviynt)',
  NO: 'NO',
  SAVIYNT_TITLE: 'Saviynt',
  SOURCE_NOT_CONFIGURED_ALERT: 'Source not configured',
  ENABLE_DATA_MIGRATION: 'Enable Data Migration',
  ENABLE_AI_AGENT_SERVICE: 'Enable AI Agent Service',
  ENABLE_DISCONNECTED_DISCOVERY: 'Enable Disconnected Discovery',
};

// Attribute Mapping Modal Labels
export const ATTRIBUTE_MAPPING_LABELS = {
  TITLE: 'Attribute Mapping',
  SAVIYNT_ATTRIBUTE: 'Saviynt Attribute',
  SAILPOINT_ATTRIBUTE: 'SailPoint Attribute',
  OIM_ATTRIBUTE: 'OIM Attribute',
  SELECT_SAVIYNT: 'Select Saviynt attribute',
  SELECT_SAILPOINT: 'Select SailPoint attribute',
  SELECT_OIM: 'Select OIM attribute',
  ADD_MAPPING: 'Add Mapping',
  MAPPED_ATTRIBUTES: 'Mapped Attributes',
  CANCEL: 'Cancel',
  SAVE_MAPPINGS: 'Save Mappings',
  ERROR_SELECT_BOTH: 'Please select both Saviynt and SailPoint attributes',
  ERROR_SELECT_BOTH_OIM: 'Please select both Saviynt and OIM attributes',
  ERROR_MIN_ONE_MAPPING: 'Please add at least one attribute mapping before saving',
  SAVING: 'Saving...',
  USER_ATTRIBUTE_NOT_SAVED_CONNECTED: 'Map the required attributes and save your changes.',
  USER_ATTRIBUTE_NOT_SAVED_DISCONNECTED:
    'Please run discovery first. Once complete, map the required attributes and save your changes.',
  USER_ATTRIBUTE_NOT_SAVED_CONFIG_DATA:
    'User attribute mapping is required. Please configure it in Prerequisite Settings to proceed.',
};
